/*
redactProfileHelper.ts
Copyright © 2026 Xerox Corporation. All Rights Reserved.

Copyright protection claimed includes all forms and matters of copyrightable material
and information now allowed by statutory or judicial law or hereinafter granted,
including without limitation, material generated from the software programs which
are displayed on the screen such as icons, screen display looks, etc.
*/

import { RedactProfile } from "./redactProfile"


export const isProfileDirty = (selected: RedactProfile | null | undefined, draft: RedactProfile | null | undefined): boolean => {
    if (!selected || !draft) return false;
    
    // Compare standard fields by sorting and stringifying
    const selectedStandardSorted = [...selected.standardFields].sort((a, b) => a.googleId.localeCompare(b.googleId));
    const draftStandardSorted = [...draft.standardFields].sort((a, b) => a.googleId.localeCompare(b.googleId));
    
    if (JSON.stringify(selectedStandardSorted) !== JSON.stringify(draftStandardSorted)) {
        return true;
    }
    
    // Compare custom fields by sorting and stringifying (excluding DeviceGuid)
    const selectedCustomFiltered = selected.customFields.map(({ text: Text, contains: Contains }) => ({ Text, Contains }))
        .sort((a, b) => a.Text.localeCompare(b.Text));
    const draftCustomFiltered = draft.customFields.map(({ text: Text, contains: Contains }) => ({ Text, Contains }))
        .sort((a, b) => a.Text.localeCompare(b.Text));
    
    if (JSON.stringify(selectedCustomFiltered) !== JSON.stringify(draftCustomFiltered)) {
        return true;
    }
    
    return false;
}